import React from "react";
import PropTypes from "prop-types";
import * as d3 from "d3";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";

class PoActivityStatus extends React.Component {
  state = {
    barData: "",
    paginatedBarData: { 
      currentBarData:'',
      currentBarPage: 1,
      totalBarPage: ''
    }
  };

  componentDidMount() {
    this.getAllData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allCsvData !== this.props.allCsvData) {
      this.getAllData();
    }
  }

  getAllData = () => {
    let { allCsvData, districtName } = this.props;
    let { data, columns } = allCsvData;
    let requiredCols = [
      "Partner Organization",
      "District",
      "GaPaNa_Name",
      "Sector",
      "Activity Type",
      "Activity Status",
      "Unit (Indicator)",
      "Total Planned",
      "Total Reached",
      "Physical Target - Planned",
      "Physical Target - Reached"
    ];
    allCsvData =
      data &&
      data.filter(
        d =>
          d &&
          districtName &&
          d.District.toUpperCase() === districtName.toUpperCase()
      );
      let cols = columns && columns.filter(d => requiredCols.includes(d));
      let barData = this.getBarData(data, cols, districtName);
      let totalBarPage = Math.ceil((barData && barData.length) / 8);
      let currentBarData = barData && barData.slice(0, 8);
      
      this.setState({
      csvData: allCsvData,
      cols,
      barData,
      paginatedBarData: { currentBarData, currentBarPage: 1, totalBarPage }
    });
  };

  getBarData = (data, cols, districtName) => {
    data =
      data &&
      data.filter(
        d =>
          d &&
          districtName &&
          d.District.toUpperCase() === districtName.toUpperCase()
      );
    let orgs;
    orgs = d3.map(data, d => d["Partner Organization"]).keys();
    return orgs.map(function(o) {
      let reducedData = {};
      let completed = data.filter(
        d =>
          d["Partner Organization"] === o &&
          d["Activity Status"] === "Completed"
      );
      let ongoing = data.filter(
        d =>
          d["Partner Organization"] === o && d["Activity Status"] === "Ongoing"
      );
      let planned = data.filter(
        d =>
          d["Partner Organization"] === o && d["Activity Status"] === "Planned"
      );
      reducedData.Completed = completed.length;
      reducedData.Ongoing = ongoing.length;
      reducedData.Planned = planned.length;
      reducedData.orgName = o;
      return reducedData;
    }).sort(
        (a, b) =>
            b.Completed + b.Ongoing + b.Planned -
            (a.Completed + a.Ongoing + a.Planned)
    );
  };

  chageBarData = e => {
    let {
      barData,
      paginatedBarData: { currentBarData, currentBarPage, totalBarPage }
    } = this.state;

    if (e === "down") {
      currentBarData =
        currentBarPage >= 0 && currentBarPage < totalBarPage
          ? barData && barData.slice(currentBarPage * 8, currentBarPage * 8 + 8)
          : currentBarData;
      currentBarPage =
        currentBarPage > 0 && currentBarPage < totalBarPage
          ? currentBarPage + 1
          : currentBarPage;
    } else {
      currentBarPage = currentBarPage <= 1 ? 1 : currentBarPage - 1;
      currentBarData =
        barData && barData.slice(currentBarPage * 8 - 8, currentBarPage * 8);
    }
    totalBarPage = Math.ceil(barData.length / 8);
    this.setState({
      paginatedBarData: { currentBarData, currentBarPage, totalBarPage }
    });
  };

  render() {
    let { 
      paginatedBarData: { currentBarData }
    } = this.state;

    return (
      <div className="bar-charts">
        <div className="pull-right" onClick={() => this.chageBarData("up")} style={{position: 'absolute',right: '15px',marginTop:'-15px'}}>
          <i className="fa fa-angle-double-up" />
        </div>
        <BarChart
          width={350}
          height={305}
          data={currentBarData}
          layout="vertical"
          margin={{ top: 10, right: 20, left: 40 }}
        >
          <XAxis type="number" orientation="top" />
          <YAxis type="category" dataKey="orgName" />
          <Tooltip />
          <Legend />
          <Bar dataKey="Completed" stackId="a" fill="#8884d8" barSize={150} />
          <Bar dataKey="Ongoing" stackId="a" fill="#82ca9d" barSize={150} />
          <Bar dataKey="Planned" stackId="a" fill="#82ca00" barSize={150} />
        </BarChart>
        <div className="pull-right" onClick={() => this.chageBarData("down")}>
          <i className="fa fa-angle-double-down" />
        </div>
      </div>
    );
  }
}

PoActivityStatus.propTypes = {
  districtName: PropTypes.string.isRequired,
  allCsvData: PropTypes.object.isRequired
};

export default PoActivityStatus;
